/**
 * @generated SignedSource<<0c9166144892b6e086da8426f9220f0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentCard_ContentFragment$data = {
  readonly coverPhoto: string | null;
  readonly coverVideo: string | null;
  readonly coverVideoAssetUsage: {
    readonly asset: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"DiscoVideoFragment">;
    };
    readonly id: string;
  } | null;
  readonly id: string;
  readonly showCoverPlayIcon: boolean;
  readonly thumbnailUrl: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"BookmarkButtonContentFragment" | "ContentAttachmentsSectionFragment" | "ContentDescriptionSectionFragment" | "ContentFooterSection_ContentFragment" | "ContentHeaderSectionFragment" | "ContentMediaSectionFragment" | "ContentTitleSectionFragment">;
  readonly " $fragmentType": "ContentCard_ContentFragment";
};
export type ContentCard_ContentFragment$key = {
  readonly " $data"?: ContentCard_ContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentCard_ContentFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentCard_ContentFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "coverVideo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetUsage",
      "kind": "LinkedField",
      "name": "coverVideoAssetUsage",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "asset",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DiscoVideoFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "coverPhoto",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnailUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showCoverPlayIcon",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentHeaderSectionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentMediaSectionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentTitleSectionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentDescriptionSectionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentAttachmentsSectionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentFooterSection_ContentFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookmarkButtonContentFragment"
    }
  ],
  "type": "Content",
  "abstractKey": null
};
})();

(node as any).hash = "ee2a559333fd0364f0dd5841754449b3";

export default node;
